<template>
  <div id="navbar_top_links" class="w-full flex justify-start sm:justify-end">
    <top-links
      :link_data="link_data" :organization_id="organization_id" :tour="tour"
    ></top-links>
  </div>
</template>

<script>
  import TopLinks from "./top_links";

  export default {
    components: {
      TopLinks,
    },
    props: {
      link_data: Object,
      organization_id: String,
      role: String,
      tour: String
    },
    data: function() {
      return {
        current_user: null,
      }
    },
    computed: {
    },
    mounted: function() {
    },
    methods: {
    }

  };
</script>

<style lang="scss" scoped>
</style>
